<div *ngIf="user">
  <div mat-dialog-title>
    <div *ngIf="user.id" i18n>Edit User</div>
    <div *ngIf="!user.id" i18n>Add User</div>
  </div>
  <p class="form-inline mb-2">
    <span *ngIf="user.id" i18n>To edit a user, update the form below then click Submit</span>
    <span *ngIf="!user.id" i18n>To add a new user, complete the form below then click Submit</span>
    <span class="float-right warning col-sm-4" i18n>
      * Required Information
    </span>
  </p>
  <form #form="ngForm" (ngSubmit)="saveUser(form)">
    <div class="row" mat-dialog-content>
      <div class="form-group form-inline row-cols-md-2 row-cols-1">
        <div class="form-group pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="firstName" i18n>First Name</label>
          <div>
            <input id="firstName" name="firstName" class="form-control" [(ngModel)]="user.firstName"
                   required #firstName="ngModel"
                   [class.field-error]="form.submitted && firstName.invalid">
            <div [hidden]="!form.submitted || firstName.valid"
                 class="alert alert-danger" i18n>Enter a first name</div>
          </div>
        </div>
        <div class="form-group pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="lastName" i18n>Last Name</label>
          <div>
            <input id="lastName" name="lastName" class="form-control" [(ngModel)]="user.lastName"
                   required #lastName="ngModel"
                   [class.field-error]="form.submitted && lastName.invalid">
            <div [hidden]="!form.submitted || lastName.valid"
                 class="alert alert-danger" i18n>Enter a last name</div>
          </div>
        </div>
      </div>
      <div class="form-group form-inline">
        <div class="form-group pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="role_ID" i18n>User Role</label>
          <div>
            <select (change)="onRoleSelectionChange()" name="role_ID" id="role_ID" class="form-control" [(ngModel)]="user.role_ID" required #roleOption="ngModel">
              <option [ngValue]="undefined" selected="">-</option>
              <option *ngFor="let role of roles" [ngValue]="role.role_ID">{{role.role_Name}}</option>
            </select>
            <div [hidden]="!form.submitted || roleOption.valid"
                 class="alert alert-danger" i18n>Select a user role</div>
          </div>
        </div>
        <div *ngIf="user.dealer_ID">
          <div class="form-group pr-2">
            <label class="pr-2" for="selectedOfficeId" i18n>Office</label>
            <select [(ngModel)]="user.office_ID" name="office_ID" id="selectedOfficeId" class="form-control col-md-9">
              <option [ngValue]="undefined" selected="">-</option>
              <option *ngFor="let office of offices" [(ngValue)]="office.office_ID">{{office.office_Name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-inline form-group  row-cols-md-2 row-cols-1">
        <div class="form-group pr-2">
          <span *ngIf="biditUser" class="warning">* </span>
          <label class="pr-2" for="email" i18n>Email</label>
          <div>
            <input id="email" name="email" type="email" [required]="biditUser"
                   placeholder="email"
                   class="form-control"
                   [(ngModel)]="user.email"
                   #email="ngModel" />
            <div *ngIf="biditUser" [hidden]="!form.submitted || email.valid"
                 class="alert alert-danger" i18n>Enter an email</div>
          </div>
        </div>
        <div class="form-group pr-2">
          <span *ngIf="biditUser" class="warning">* </span>
          <label class="pr-2" for="phoneNumber" i18n>Cell #</label>
          <div>
            <input id="phoneNumber" name="phoneNumber" type="tel" [required]="biditUser"
                   placeholder="(999) 999-9999" appPhoneMask
                   class="form-control col"
                   [(ngModel)]="user.phoneNumber"
                   #phoneNumber="ngModel" />
            <div *ngIf="biditUser" [hidden]="!form.submitted || phoneNumber.valid"
                 class="alert alert-danger" i18n>Enter a cell # number</div>
          </div>
        </div>
      </div>
      <div class="form-inline form-group  row-cols-md-2 row-cols-1">
        <div class="form-group pr-2">
          <mat-checkbox i18n id="newLeadNotification" name="newLeadNotification"
                        [(ngModel)]="user.turnOffNewLeadNotification">
            Turn Off New Lead Notifications
          </mat-checkbox>
        </div>
        <div class="form-group pr-2">
          <label class="pr-2" for="role_ID" i18n>Calendar Default</label>
          <select id="calendarView" name="calendarView" class="form-control select-bidit" [(ngModel)]="user.calendarView">
            <option value='Month'>Month</option>
            <option value='Week'>Week</option>
            <option value='Day'>Day</option>
          </select>
        </div>
      </div>
      <!--<div class="form-inline form-group  row-cols-md-2 row-cols-1">
        
      </div>-->
      <div *ngIf="rolePermissions">
        <div class="mt-5">
          <h5 i18n>Role Permissions</h5>
          <div class="row row-cols-1 row-cols-md-2">
            <ng-container *ngFor="let rolePerm of rolePermissions">
              <div *ngIf="displayRole(rolePerm)">
                <div class="card border-0">
                  <div class="card-body">
                    <h5 class="card-title">{{rolePerm.moduleName}}</h5>
                    <div *ngFor="let perm of rolePerm.permissions">
                      <mat-checkbox *ngIf="displayPerm(perm)"
                                    disabled id="{{perm.perm_ID}}" name="{{perm.perm_Key}}"
                                    [(ngModel)]="perm.isSelected">
                        {{perm.perm_Desc}}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="errors" class="row alert alert-danger" role="alert">
      <strong>{{errors}}</strong>
    </div>
    <mat-dialog-actions align="end">
      <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
    <div class="mt-3">
      <div [hidden]="!form.submitted || form.valid"
           class="alert alert-danger" i18n>
        Validation issues encountered.  Please review your entered information.
      </div>
    </div>
  </form>
</div>
